import { useCallback, useEffect, useState } from 'react';

import { ViewApiService } from '../../infrastructure/ViewApiService';

export const useGeniallyName = (geniallyId: string) => {
  const [geniallyName, setGeniallyName] = useState<string | undefined>(undefined);

  const getGeniallyName = useCallback(async () => {
    const name = await ViewApiService.getGeniallyName(geniallyId);

    setGeniallyName(name);
  }, [geniallyId]);

  useEffect(() => {
    if (geniallyId) {
      getGeniallyName();
    }
  }, [geniallyId, getGeniallyName]);

  return geniallyName;
};
